<template>
	<div class="has-text-centered is-inline">
		<div
			v-if="mode == 'add' || mode == 'edit'"
			v-for="(rate, index) in range"
			class="is-inline">
			<button
				class="button is-large has-text-warning p-2"
				:key="'button' + index"
				:data-tippy-content="wordRating[index]"
				@mouseover="temp = rate"
				@click="rating = rate"
				@mouseleave="temp = 0">
				<span
					v-show="temp >= rate || rating >= rate"
					:key="'filled' + index">
					<i class="fas fa-star"></i>
				</span>
				<span
					v-show="!(temp >= rate || rating >= rate)"
					:key="'empty' + index">
					<i class="far fa-star"></i>
				</span>
			</button>
		</div>
		<div
			v-if="mode == 'view'"
			v-for="(rate, index) in range"
			class="is-inline">
			<span
				:class="'is-inline has-text-warning pl-0 pr-0 ' + textSize"
				:key="'button' + index"
				:data-tippy-content="wordRating[index]">
				<span
					v-show="temp >= rate || rating >= rate"
					:key="'filled' + index">
					<i class="fas fa-star"></i>
				</span>
				<span
					v-show="!(temp >= rate || rating >= rate)"
					:key="'empty' + index">
					<i class="far fa-star"></i>
				</span>
			</span>
		</div>
		<div
			v-if="mode == 'estimate'"
			v-for="(rate, index) in range"
			class="is-inline">
			<span
				:class="'is-inline has-text-warning pl-0 pr-0 ' + textSize"
				:key="'button' + rating"
				:data-tippy-content="wordRating[index]">
				<span
					v-show="estimator(rating, index) == 'full'"
					:key="'filled' + index">
					<i class="fas fa-star"></i>
				</span>
				<span
					v-show="estimator(rating, index) == 'empty'"
					:key="'empty' + index">
					<i class="far fa-star"></i>
				</span>
				<span
					v-show="estimator(rating, index) == 'half'"
					:key="'half' + index">
					<i class="fas fa-star-half-alt"></i>
				</span>
			</span>
		</div>
	</div>
</template>
<style scoped>
	.is-clickable {
		cursor: pointer;
	}

	.no-decorations {
		text-decoration: none;
	}

	.border-radius-100 {
		border-radius: 100%;
	}

	.button {
		border: none;
		box-shadow: none;
	}

	.button:hover,
	.button.is-hovered {
		border: none;
		box-shadow: none;
	}

	.button:focus:not(:active) {
		border: none;
		box-shadow: none;
	}

	.button:active,
	.button.is-active {
		border: none;
		box-shadow: none;
	}
</style>
<script>
	import tippy from "tippy.js";

	export default {
		props: {
			mode_prop: String,
			text_size_prop: Number,
			rating_prop: Number,
		},
		data() {
			return {
				rating: 0,
				temp: 0,
				range: [1, 2, 3, 4, 5],
				wordRating: ["Bad", "Alright", "Good", "Very Good", "Excellent"],
			};
		},
		computed: {
			mode() {
				if (typeof this.mode_prop !== "undefined") {
					switch (this.mode_prop) {
						case "edit":
							return "edit";
							break;
						case "view":
							return "view";
							break;
						case "estimate":
							return "estimate";
							break;
					}
				}
				return "add";
			},
			textSize() {
				let size = this.text_size_prop ? this.text_size_prop : 6;
				return "is-size-" + size;
			},
		},
		mounted() {
			let _this = this;
			if (this.mode == "add" || this.mode == "edit") {
				setTimeout(() => {
					tippy("[data-tippy-content]"),
						{
							delay: [200, 400],
							duration: [600, 450],
						};
				}, 500);
			}
			if (this.mode == "view" || this.mode == "estimate") {
				this.$nextTick(() => {
					this.value(this.$props.rating_prop);
				});
			}
		},
		methods: {
			value(value) {
				if (value) {
					if (value < 0) {
						this.rating = 0;
					} else if (value > 5) {
						this.rating = 5;
					} else {
						this.rating = value;
					}
				}
				return this.rating;
			},
			mouseOver() {
				switch (this.mode) {
					case "edit":
						this.temp = this.rate;
						break;
					case "view":
						// Intentionally Blank
						break;
				}
			},
			mouseLeave() {
				switch (this.mode) {
					case "edit":
						this.temp = 0;
						break;
					case "view":
						// Intentionally Blank
						break;
				}
			},
			click() {
				switch (this.mode) {
					case "edit":
						this.rating = this.rate;
						break;
					case "view":
						// Intentionally Blank
						break;
				}
			},
			estimator(value, index) {
				let floor = Math.floor(value);
				let decimal = value - floor;
				if (index + 1 <= floor) {
					return "full";
				} else if (index <= floor && decimal > 0 && decimal <= 0.75) {
					return "half";
				} else if (index <= floor && decimal > 0.75 && decimal < 0.99) {
					return "full";
				} else {
					return "empty";
				}
			},
		},
		watch: {
			rating_prop: function () {
				if (this.mode == "estimate" || this.mode == "view") {
					this.value(this.$props.rating_prop);
				}
			},
		},
	};
</script>
